import { useState } from 'react'

import { useAPIUsersBuktiKaryaByCategory } from 'api/bukti-karya/useAPIBuktiKaryaList'

const DEFAULT_PAGE_SIZE = 6

export const useBuktiKarya = (userId: string, category: string) => {
  const [timesFetched, setTimesFetched] = useState(0)
  const { data, fetchNextPage, hasNextPage, isLoading, isFetchingNextPage } =
    useAPIUsersBuktiKaryaByCategory(userId, category, {
      pageSize: DEFAULT_PAGE_SIZE,
    })

  // The API doesn't allow more than 6 data per request so we have to fetch 2 times
  // to prevent issues on taller screens
  if (hasNextPage && !isFetchingNextPage && timesFetched !== 2) {
    fetchNextPage().then(() => {
      setTimesFetched(2)
    })
  }

  return {
    data: data?.pages.flatMap((page) => page.data) ?? [],
    fetchNextPage,
    hasNextPage,
    isLoading,
  }
}
